<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Content Scroll Bar" pageTitle="Content Scroll Bar" />
            <ContentScrollBar />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import ContentScrollBar from '../ContentScrollBar/ContentScrollBar'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'ContentScrollBarPage',
    components: {
        MainHeader,
        PageTitle,
        ContentScrollBar,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>